module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-136.739153c5.svg";